// 目前可以找到的 国际版手机号通用正则
const mobileReg = [
    /^(00){0,1}(61){1}4\d{8,9}$/, // 澳大利亚
    /^(00){0,1}(1){1}\d{10}$/, // 加拿大
    /^(\+?1)?[2-9]\d{2}[2-9](?!11)\d{6}$/, // 美国
    /^(\+?420)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/, // 捷克共和国
    /^(00){0,1}(253){1}\d{6,15}$/, // 德国
    /^(\+?45)?(\d{8})$/, // 丹麦
    /^(\+?30)?(69\d{8})$/, // 希腊
    /^(00){0,1}(355){1}\d{6,15}$/, // 阿尔巴尼亚
    /^(\+?44|0)7\d{9}$/, // 英国
    /^(\+?91|0)?[789]\d{9}$/, // 印度
    /^(00){0,1}(852){1}0{0,1}[1,5,6,9](?:\d{7}|\d{8}|\d{12})$/, // 中国香港
    /^(00){0,1}(229){1}\d{6,15}$/, // 中国澳门
    /^(00){0,1}(60){1}1\d{8,9}$/, // 马来西亚
    /^(00){0,1}(65){1}[13689]\d{6,7}$/, // 新加坡
    /^(00){0,1}(82){1}0{0,1}[7,1](?:\d{8}|\d{9})$/, // 韩国
    /^(\+?64|0)2\d{7,9}$/, // 新西兰
    /^(\+?27|0)\d{9}$/, // 南非
    /^(\+?34)?(6\d{1}|7[1234])\d{7}$/, // 西班牙
    /^(\+?358|0)\s?(4(0|1|2|4|5)?|50)\s?(\d\s?){4,8}\d$/, // 芬兰
    /^(\+?33|0)[67]\d{8}$/, // 法国
    /^(\+972|0)([23489]|5[0248]|77)[1-9]\d{6}/, // 以色列
    /^(\+?36)(20|30|70)\d{7}$/, // 匈牙利
    /^(\+?39)?\s?3\d{2} ?\d{6,7}$/, // 意大利
    /^(00){0,1}(81){1}0{0,1}[7,8,9](?:\d{8}|\d{9})$/, // 日本
    /^(\+?47)?[49]\d{7}$/, // 挪威
    /^(\+?32|0)4?\d{8}$/, // 比利时
    /^(\+?48)? ?[5-8]\d ?\d{3} ?\d{2} ?\d{2}$/, // 波兰
    /^(00){0,1}(855){1}\d{6,12}$/, // 巴西
    /^(\+?351)?9[1236]\d{7}$/, // 葡萄牙
    /^(\+?7|8)?9\d{9}$/, // 俄罗斯
    /^(\+?90|0)?5\d{9}$/, // 土耳其
    /^(86){0,1}1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/, // 中国大陆
    /^(00){0,1}(886){1}0{0,1}[6,7,9](?:\d{7}|\d{8}|\d{10})$/, // 中国台湾地区
];

// 获取主表id
export function getMainId(areaCode, meta, moduleType) {
    let mainId = areaCode;
    if (moduleType === 'form') {
        // 有可能这里配的是表单分组id，需要根据 formrelation 找到主表id
        if (meta?.formrelation) {
            for (const key in meta.formrelation) {
                if (Object.hasOwnProperty.call(meta.formrelation, key)) {
                    const element = meta.formrelation[key];
                    element?.includes(mainId) && meta[key]?.moduletype === 'form' && (mainId = key);
                }
            }
        }
        // 还有一种情况，配置的是多页签表单 tabs其他tab，需要根据 formassociatedrelation 找到主表id
        if (meta?.formassociatedrelation) {
            for (const key in meta.formassociatedrelation) {
                if (Object.hasOwnProperty.call(meta.formassociatedrelation, key)) {
                    const element = meta.formassociatedrelation[key]['formtabs'];
                    element?.includes(mainId) && meta[key]?.moduletype === 'form' && (mainId = key);
                }
            }
        }
    }

    if (moduleType === 'table') {
        // 再去  containerrelation 找 二维数组 的  key
        // 根据 gridrelation 找到主表id
        if (meta?.gridrelation) {
            for (const key in meta.gridrelation) {
                if (Object.hasOwnProperty.call(meta.gridrelation, key)) {
                    const element = meta.gridrelation[key]['tabRelation'];
                    element?.includes(mainId) && meta[key]?.moduletype === 'table' && (mainId = key);
                }
            }
        }
        // 根据 containerrelation 找到主表id
        if (meta?.containerrelation) {
            for (const key in meta.containerrelation) {
                if (Object.hasOwnProperty.call(meta.containerrelation, key)) {
                    const element = meta.containerrelation[key];
                    // 注意：这里是一个二维数组
                    if (Array.isArray(element)) {
                        let flag = element.some(ele => ele.includes(mainId));
                        flag && meta[key]?.moduletype === 'table' && (mainId = key);
                    }
                }
            }
        }
    }

    return mainId;
}

// 将字符串转化为js执行代码
export function evalPro(str) {
    let Fn = Function;
    return new Fn('return /' + str + '/')();
}

// 把layout表单表格props属性的fieldInfo 转到items的具体字段
export function translateLayoutReg(meta) {
    const { layout: newLayout = '[]', multiLangItems = [] } = meta;
    // 从 layout 取正则 正则多语
    let layout = [];
    try {
        layout = JSON.parse(newLayout);
    } catch (error) {
        layout = [];
    }
    const layoutPath = ['LowCodeComponents.NCForm', 'LowCodeComponents.NCTable', 'LowCodeComponents.NCCardTable', 'LowCodeComponents.NCFormCard'];
    const regMessagePath = 'regMessage';
    const regTypeMap = {
        tel: val => {
            let result = mobileReg.some(reg => reg.test(val));
            return result;
        },
        idcard: val => {
            let p = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}([0-9]|x|X)$/;
            let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
            let parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2];
            let code = val.substring(17);
            if (p.test(val)) {
                let sum = 0;
                for (let i = 0; i < 17; i++) {
                    sum += val[i] * factor[i];
                }
                if (parity[sum % 11] == code.toUpperCase()) {
                    return true;
                }
            }
            return false;
        },
        // idcard: /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|3[0-1])|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}([0-9]|x|X)$/,
        email: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
    };
    Object.keys(meta).forEach(moduleId => {
        if (meta[moduleId] && meta[moduleId].moduletype) {
            let mainId = getMainId(moduleId, meta, meta[moduleId].moduletype);
            let formLayout = layout.find(item => item?.props?.moduleId === mainId && layoutPath.includes(item.path)) || {};
            let { props = {} } = formLayout;
            let { fieldInfo = [] } = props;
            meta[moduleId].items.forEach(item => {
                // 从这里开始取正则 正则多语
                let currentFieldInfo = fieldInfo.find(field => field.itemCode === item.attrcode) || {};
                let { regType, reg, areaCode, freezeCol, designlabelcontent, attachmentParmas, isdetailfield } = currentFieldInfo;
                // moduleid 区域 id itemcode 当前项 id itempath "fieldInfo[n].regMessage" 正则校验信息
                let regMessage = multiLangItems.find(langItem => (langItem?.itempath?.endsWith(regMessagePath) && langItem.itemcode === item.attrcode && langItem.moduleid === areaCode))?.tranitemvalue;
                if (regType === 'other' && reg) {
                    // regType 是 other 解析模板设置的自定义校验
                    item.reg = evalPro(reg);
                    item.regMessage = regMessage;
                } else if (regTypeMap[regType]) {
                    // regType 是 电话 邮箱 身份证
                    item.reg = regTypeMap[regType];
                    item.regMessage = regMessage;
                }
                item.freezeCol = freezeCol;
                item.isdetailfield = isdetailfield;
                item.designlabelcontent = designlabelcontent || item.designlabelcontent;
                item.attachmentParams = attachmentParmas;
            });
        }
    });
}
